import { Grid, GridItem, Image } from "@chakra-ui/react";
import noPreview from "../../assets/no-preview-available.png";
import { GalleryOpenButton } from "./FullScreenButton";

/**
 * Desktop accommodation hero — Airbnb-style photo grid.
 * Opens the main gallery via parent onOpen callback.
 */
export function GalleryGrid({ images = [], onOpen, imageCount }) {
  const count = imageCount ?? images.length;

  return (
    <Grid
      className="fursatook-gallery-grid"
      position="relative"
      templateRows="repeat(2, 1fr)"
      templateColumns="repeat(4, 1fr)"
      onClick={onOpen}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpen?.();
        }
      }}
      aria-label="Open photo gallery"
    >
      <GridItem className="fursatook-gallery-grid__cell--hero" rowSpan={2} colSpan={2}>
        <Image
          cursor="pointer"
          h="100%"
          w="100%"
          objectFit="cover"
          src={images[0] ?? noPreview}
          alt=""
        />
      </GridItem>
      {images.slice(1, 5).map((image, index) => (
        <GridItem
          key={index}
          className="fursatook-gallery-grid__cell"
          row={Math.floor(index / 2) + 1}
          column={(index % 2) + 3}
        >
          <Image
            cursor="pointer"
            h="100%"
            w="100%"
            objectFit="cover"
            src={image ?? noPreview}
            alt=""
          />
        </GridItem>
      ))}
      <GalleryOpenButton label={count} />
    </Grid>
  );
}
